<div class="warnings" tourAnchor="atrefakt-tour" *ngIf="activeTrainingStep">
  <h4>
    {{ "YOUTUBE_VIDEO.ARTEFACT_TEXT" | translate }}
    <img (click)="triggerArtefakt()" [src]="showArtefaktSignal ? './assets/visibility-icons/show.png' : './assets/visibility-icons/hide.png'" alt="img">
  </h4>
  <p class="artefakt-value" *ngIf="currentArtefakt && showArtefaktSignal">{{currentArtefakt}}</p>
  <div class="artefact-container" *ngIf="showArtefaktSignal">
    <mat-radio-group class="radio-buttons" [ngModel]="artefactTresHold" (change)="setArtefakt($event)" *ngIf="tenant.current.id !== 'feelen'">
      <mat-radio-button value="2">2</mat-radio-button>
      <mat-radio-button value="4">4</mat-radio-button>
      <mat-radio-button value="6">6</mat-radio-button>
    </mat-radio-group>
    <div class="lighter">
      <div class="dot" [ngClass]="showGreenColor ? 'green' : 'dot'"></div>
      <div class="dot" [ngClass]="showYellowColor ? 'yellow' : 'dot'"></div>
      <div class="dot" [ngClass]="showRedColor ? 'red' : 'dot'"></div>
    </div>
  </div>
</div>
